function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["isActive", "fileNameFormat"];
var _templateObject, _templateObject2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React, { useMemo } from 'react';
import styled from 'styled-components';
import FileDownloadIcon from '../FileDownloadIcon';
import FileTypeIcon, { getFileType } from '../FileTypeIcon';
import { Tooltip } from 'antd';
import { formart_ss } from '@core/shared';
var FileItemWrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  max-width: 100%;\n"])));
var FileNameText = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-left: 4px;\n  margin-right: 16px;\n  line-height: 20px;\n  font-size: 14px;\n\n  font-weight: 400;\n  color: ", ";\n  cursor: ", ";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  &:hover {\n    color: ", ";\n  }\n"])), function (props) {
  return props.isActive ? 'var(--lj-primary-color)' : 'rgba(0, 0, 0, 0.55)';
}, function (props) {
  return props.isActive ? 'pointer' : 'default';
}, function (props) {
  return props.isActive ? 'var(--lj-primary-color-hover)' : 'rgba(0, 0, 0, 0.55)';
});
export function FileItem(props) {
  var isActive = props.isActive,
    fileNameFormat = props.fileNameFormat,
    rest = _objectWithoutProperties(props, _excluded);
  var fileTypeMemo = useMemo(function () {
    if (!props.fileName) {
      return '';
    }
    var fileType = props.fileName.split('.').pop();
    if (!fileType || !fileType.toLowerCase) {
      return '';
    }
    return fileType.toLowerCase();
  }, [props.fileName]);
  var isActiveMemo = useMemo(function () {
    if (isActive !== undefined) {
      return !!isActive;
    }
    if (!fileTypeMemo) {
      return false;
    }
    if (['pdf', 'mp4', 'jpg', 'svg', 'jpeg', 'png', 'gif', 'bmp', 'tif', 'webp'].includes(fileTypeMemo)) {
      return true;
    }
    var type = getFileType(props.fileName);
    if (type === 'jpg' || type === 'mp4') {
      return true;
    }
    return false;
  }, [isActive, props.fileName, fileTypeMemo]);
  return /*#__PURE__*/React.createElement(FileItemWrap, {
    className: "FileItemWrap"
  }, /*#__PURE__*/React.createElement(FileTypeIcon, _objectSpread({
    fileName: props.fileName
  }, rest)), /*#__PURE__*/React.createElement(FileNameText, {
    isActive: isActiveMemo,
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      if (isActiveMemo && props.fileSrcUrl) {
        window.open(props.fileSrcUrl);
      }
    }
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: /*#__PURE__*/React.createElement("div", null, "\u4E0A\u4F20\u65F6\u95F4\uFF1A", formart_ss(props.modiDatetime))
  }, fileNameFormat ? fileNameFormat(props.fileName) : props.fileName)), /*#__PURE__*/React.createElement(FileDownloadIcon, _objectSpread({}, rest)));
}
export var FilePreviewItem = FileItem;